var map = {
	"./TotalCyberComplianceDark_Medium.svg": 92252,
	"./TotalCyberCompliance_Medium.svg": 19352,
	"./TotalHipaaDark_Medium.svg": 95125,
	"./TotalHipaa_Medium.svg": 87517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98468;